module.exports = __webpack_public_path__ + "img/fig02.93109f39.jpg";